<template>
  <div class="team-layout">
    {{outlet}}
  </div>
</template>
